import React from 'react';
import RandomString from 'randomstring';

import DialogAddCriteria from './MS/DialogAddCriteria';
import CreatePanelProtocolMSTable from './MS/TableCriteria';

class CreatePanelProtocolMS extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dialogIsOpen: false,
            criteria: {
                name: null,
                default: 5,
                min: 1,
                max: 10,
                step: 1
            }
        }
    }

    handleOpenDialog = () => this.setState({ dialogIsOpen: true });
    handleCloseDialog = () => this.setState({ dialogIsOpen: false });

    handleChangeInput = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        const currentCriteriaState = this.state.criteria;
        this.setState({ criteria: { ...currentCriteriaState, [name]: value } });
    }
    handleChangeNumericInput = (name, value) => {
        const currentCriteriaState = this.state.criteria;

        this.setState({ criteria: { ...currentCriteriaState, [name]: value } });
    }
    handleAddCriteria = () => {
        let { criteria } = this.state;
        const { criterias, onChangeCriterias } = this.props;
        if (criteria.type === 'OPEN') {
            criteria = { name: criteria.name, type: criteria.type, default: "" }
        }
        criteria.id = RandomString.generate(16);
        criterias.push(criteria);
        onChangeCriterias(criterias);
        this.setState({ criteria: { name: null, default: 5, min: 1, max: 10, step: 1 } });
        this.handleCloseDialog();
    }
    handleDeleteCriteria = (id) => {
        let { criterias, onChangeCriterias } = this.props;

        // Delete the element that has the given id using Array.filter
        criterias = criterias.filter((c) => c.id !== id);
        onChangeCriterias(criterias);
    }

    render() {
        const { criterias, instances = [] } = this.props;
        const { criteria, dialogIsOpen } = this.state;

        return (
            <div>
                <DialogAddCriteria
                    criteria={criteria}
                    dialogIsOpen={dialogIsOpen}
                    onCloseDialog={this.handleCloseDialog}
                    onChangeInput={this.handleChangeInput}
                    onChangeNumericInput={this.handleChangeNumericInput}
                    onAddCriteria={this.handleAddCriteria} />
                <CreatePanelProtocolMSTable
                    instances={instances}
                    criterias={criterias}
                    onDeleteCriteria={this.handleDeleteCriteria}
                    onOpenDialog={this.handleOpenDialog} />
            </div>
        )
    }
}

export default CreatePanelProtocolMS;